






























import { Vue, Component, Prop } from 'vue-property-decorator'
import { LoginUser } from '@/types/user'
import PatientVideoCallRoom, { ScreenMode } from './PatientVideoCallRoom.vue'

@Component({
  components: {
    VideoCallContainer: () =>
      import('@/components/common/videoCallRoom/VideoCallContainer.vue'),
    PatientVideoCallRoom: PatientVideoCallRoom
  }
})
export default class PatientVideoCall extends Vue {
  @Prop(Object) user!: LoginUser

  isScreenListing = false

  handeleChangeScreenMode(mode: ScreenMode) {
    this.isScreenListing = mode === ScreenMode.LISTING
  }

  handleLocalHangUp() {
    this.isScreenListing = false
  }
}
